/** @jsxImportSource @emotion/react */

import React from 'react'
import { DrawerSubMenuItem } from './DrawerSubMenuItem'
import { Collapse, List } from '@mui/material'

import { MenuType } from '@redux/index'

interface PropsType {
	menu: MenuType
	anchorEl: any
	isOpenSubmenu: boolean
	onCloseSubmenu: () => void
	onNavigateClick: (menu: MenuType) => void
}

export const DrawerSubMenuList = (props: PropsType) => {
	return (
		<>
			{props.menu.children !== undefined ? (
				<Collapse in={props.isOpenSubmenu} timeout="auto" unmountOnExit>
					<List component="div" disablePadding>
						{props.menu.children.map((aSubMenu: MenuType) => (
							<DrawerSubMenuItem
								key={aSubMenu.id}
								subMenu={aSubMenu}
								onNavigateClick={props.onNavigateClick}
							/>
						))}
					</List>
				</Collapse>
			) : null}
		</>
	)
}
